
import Vue from 'vue';
import { trackContactClick, trackButtonClick } from '~/utility/tracking';
import { scrollToAnchorWhenReady } from '~/utility/helpers';

export default Vue.extend({
  props: {
    variant: { type: String, required: true, default: 'primary' },
    disabled: { type: Boolean, required: false },
    iconName: { type: String, required: false },
    iconPos: { type: String, required: false },
    url: { type: String, required: false },
    target: { type: String, required: false },
    label: { type: String, required: true },
    type: { type: String || null, default: null },
    isSubmit: { type: Boolean, default: false },
    trackingModule: { type: String, required: false },
  },
  data() {
    return {};
  },
  computed: {
    getType(): string {
      if (this.type) return this.type;
      return this.url && !this.url.includes('://') && !this.url.includes('mailto:') && !this.url.includes('tel:')
        ? 'nuxt-link'
        : 'a';
    },
    href(): string | undefined {
      return this.getType === 'a' ? this.url : undefined;
    },
    to(): string | undefined {
      return this.getType !== 'a' && this.url ? this.url : undefined;
    },
    getLabel(): any {
      return this.$slots.default || this.label;
    },
  },
  methods: {
    handleClick(e: Event): void {
      this.trackContactIfApplicable();
      this.trackButtonIfApplicable();
      this.scrollToAnchorIfApplicable();
      this.$emit('click', e);
    },

    scrollToAnchorIfApplicable(): void {
      if (!process.client || !this.url || !this.url.includes('#')) return;

      const hash = this.url.split('#')[1];
      if (!hash) return;

      scrollToAnchorWhenReady(hash);
    },

    trackContactIfApplicable(): void {
      if (!process.client || !this.url) return;

      if (this.url.includes('mailto:')) {
        const email = this.url.replace('mailto:', '');
        trackContactClick('email', email, this.iconName ? `icon:${this.iconName}` : undefined);
      } else if (this.url.includes('tel:')) {
        const phone = this.url.replace('tel:', '').trim();
        trackContactClick('phone', phone, this.iconName ? `icon:${this.iconName}` : undefined);
      }
    },

    trackButtonIfApplicable(): void {
      if (!process.client || !this.trackingModule || this.variant !== 'primary') return;

      // Don't track mailto: and tel: links as buttons (they're tracked as contact)
      if (this.url && (this.url.includes('mailto:') || this.url.includes('tel:'))) return;

      trackButtonClick(this.label || '', this.url || '', this.trackingModule);
    },
  },
});
